import List from "./List";
import Form from "./Form";
import { Button, Col, Drawer, Row, Space, Typography } from "antd";
import { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { cutLongText, showCnpj, showCpf } from "../../../services/utils";
import ProfilePermissionService from "../../../services/profilePermissions.service";

const { Text } = Typography;

export default function CustomersPage(props: any) {
  const [openDetails, setOpenDetails] = useState<boolean>(false);
  const [details, setDetails] = useState<any>(null);
  const navigate = useNavigate();

  const profilePermissionService = ProfilePermissionService.getInstance();

  const columns: any = [
    {
      title: "Razão Social / Nome",
      dataIndex: "name",
      sorter: true,
      key: "name",
      width: 220,
      render: (_: any, record: any) => cutLongText(record.name),
    },
    {
      title: "CNPJ / CPF",
      dataIndex: "document",
      key: "document",
      width: 170,
      render: (_: any, record: any) =>
        `${record.document_type ? (record.document_type + ': ') : ''}${
          record.document_type === "CPF"
            ? showCpf(record.document)
            : showCnpj(record.document)
        }`,
      responsive: ["md", "lg", "xl"],
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
      width: 250,
      render: (_: any, record: any) => cutLongText(record.email),
      responsive: ["md", "lg", "xl"],
    },
    {
      title: "Telefone",
      dataIndex: "phone",
      key: "phone",
      width: 150,
      responsive: ["md", "lg", "xl"],
    },
    {
      title: "Responsável",
      dataIndex: "responsible_name",
      key: "responsible_name",
      width: 200,
      render: (_: any, record: any) => cutLongText(record.responsible_name || record.name),
      responsive: ["md", "lg", "xl"],
    },    
  ];

  const label = "Cliente";

  const formFields = [
    {
      cols: [
        { field: "document_type", lg: 4, md: 4, sm:  12, xs: 24 },
        { field: "document", lg: 6, md: 6, sm:  12, xs: 24 },
        { field: "name", lg: 14, md: 14, sm:  24, xs: 24 },
      ],
    },
    {
      cols: [
        { field: "email", lg: 14, md: 14, sm:  24, xs: 24 },
        { field: "phone", lg: 6, md: 6, sm:  24, xs: 24 },
      ],
    },
    {
      cols: [
        { field: "responsible_name", lg: 14, md: 14, sm:  24, xs: 24 },
        { field: "responsible_phone", lg: 6, md: 6, sm:  24, xs: 24 },
      ],
    },
    {
      cols: [
        { field: "postal_code", lg: 4, md: 4, sm:  24, xs: 24 },
        { field: "address", lg: 12, md: 12, sm:  24, xs: 24 },
      ],
    },
    {
      cols: [
        { field: "neighborhood", lg: 8, md: 8, sm:  24, xs: 24 },
        { field: "city", lg: 8, md: 8, sm:  24, xs: 24 },
        { field: "state", lg: 4, md: 4, sm:  24, xs: 24 },
      ],
    },
    {
      cols: [
        { field: "username", lg: 6, md: 6, sm:  24, xs: 24 },
        { field: "password", lg: 6, md: 6, sm:  24, xs: 24 },
      ],
    },
    {
      cols: [{ field: "notes", lg: 24, md: 24, sm:  24, xs: 24 }],
    },
  ];

  const onOpenDetails = (record: any) => {
    setDetails(record);
    setOpenDetails(true);
  };

  const onCloseDetails = () => {
    setOpenDetails(false);
    setDetails(null);
  };

  const onMapDataToExport = (data: Array<any>) => {
    return data.map((customer: any) => {
      return {
        ID: customer.data.id,
        Cliente: customer.data.name,
        Telefone: customer.data.phone,
        "E-mail": customer.data.email,
        Documento: `${customer.data.document_type}: ${customer.data.document}`,
        Responsável: customer.data.responsible_name,
        "Telefone responsável": customer.data.responsible_phone,
        Endereço: customer.data.address,
        CEP: customer.data.postal_code,
        Bairro: customer.data.neighborhood,
        Cidade: customer.data.city,
        Estado: customer.data.state,
        Usuário: customer.data.username,
        Observações: customer.data.notes,
      };
    });
  };

  return (
    <div className="content_page">
      {props.action === "list" && (
        <>
          <List
            label={label}
            columns={columns}
            onMapDataToExport={onMapDataToExport}
            onOpenDetails={onOpenDetails}
          />

          <Drawer
            title="Detalhes"
            placement="right"
            closeIcon={false}
            width={450}
            open={openDetails}
            onClose={onCloseDetails}
            extra={
              <Button
                type="text"
                shape="circle"
                size="middle"
                icon={<CloseOutlined />}
                onClick={onCloseDetails}
              />
            }
          >
            {details && (
              <>
                <Row>
                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>Cliente</Text>
                      <Text>{details.name}</Text>
                    </Space>
                  </Col>

                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>{details.document_type}</Text>
                      <Text>
                        {details.document_type === "CPF"
                          ? showCpf(details.document)
                          : showCnpj(details.document)}
                      </Text>
                    </Space>
                  </Col>

                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>Telefone</Text>
                      <Text>{details.phone}</Text>
                    </Space>
                  </Col>

                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>E-mail</Text>
                      <Text>{details.email}</Text>
                    </Space>
                  </Col>

                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>Responsável</Text>
                      <Text>{details.responsible_name}</Text>
                    </Space>
                  </Col>

                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>Telefone responsável</Text>
                      <Text>{details.responsible_phone}</Text>
                    </Space>
                  </Col>

                  <Col span={24} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>Endereço</Text>
                      <Text>{details.address}</Text>
                    </Space>
                  </Col>

                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>CEP</Text>
                      <Text>{details.postal_code}</Text>
                    </Space>
                  </Col>

                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>Bairro</Text>
                      <Text>{details.neighborhood}</Text>
                    </Space>
                  </Col>

                  <Col span={12} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>Usuário</Text>
                      <Text>{details.username}</Text>
                    </Space>
                  </Col>

                  <Col span={24} style={{ marginBottom: 15 }}>
                    <Space direction="vertical">
                      <Text strong>Observações</Text>
                      <Text>{details.notes}</Text>
                    </Space>
                  </Col>

                  {profilePermissionService.hasPermission(
                    `customers-customers:write`
                  ) && (
                    <Col span={24} style={{ marginBottom: 15 }}>
                      <Button
                        type="primary"
                        block
                        style={{ marginTop: 20 }}
                        onClick={() => {
                          navigate(
                            `/management/customers/${details.uuid}/edit`
                          );
                          onCloseDetails();
                        }}
                      >
                        Editar
                      </Button>
                    </Col>
                  )}
                </Row>
              </>
            )}
          </Drawer>
        </>
      )}

      {props.action && ["create", "edit"].includes(props.action) && (
        <Form type="customers" action={props.action} formFields={formFields} />
      )}
    </div>
  );
}
